import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
// import { actionBtnListTopMargin } from '../../helpers';

export const DropDownContainer = styled.div`
  margin: 0 auto;
`;

export const DropDownHeader = styled('div')`
  width: 3.5rem;
  cursor: pointer;
  font-size: 2rem;
  margin-left: 60px;
  margin-top: -10px;
  z-index: 2;
  position: absolute;
`;

export const DropDownListContainer = styled.div``;

export const DropDownListOption = styled.div`
  cursor: ${props => (props.isActive ? 'pointer' : 'default')};
  width: 120px;
  color: ${props => (props.isActive ? grey.z800 : grey.z400)};
`;

export const DropDownListHeader = styled.div`
  cursor: pointer;
  font-size: 2rem;
  margin-top: -8px;
`;

export const DropDownList = styled('ul')`
  z-index: 20;
  padding-top: 10px;
  padding-left: 10px;
  font-size: 1.5rem;
  cursor: pointer;
  overflow: auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 1px 8px rgb(28 28 28 / 15%);
  &:first-child {
    padding-right: 10px;
    margin-left: -70px;
    margin-top: ${props => props.componentMarginTop};
  }
`;

export const ListItem = styled('li')`
  list-style: none;
  margin-bottom: 0.8em;
  display: flex;
  cursor: pointer;
  z-index: 200;
`;
